import React from "react";
import styles from "./index.module.css";
import warning_fill from "../assets/warning_fill.png";
import arrow_left_circle from "../assets/arrow_left_circle.png";

const ErrorPage = () => {
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <img src={warning_fill} alt="warning" className={styles.icon} />
        <h1 className={styles.title}>Oops! Your payment failed.</h1>
        <p className={styles.subtitle}>
          It looks like something went wrong. Kindly try again.
        </p>

        <button
          type="button"
          className={styles.goBack}
          onClick={() => window.history.back()}
        >
          <img src={arrow_left_circle} alt="warning" className={styles.arrowIcon} />
          Go back
        </button>
      </div>
    </div>
  );
};

export default ErrorPage;
